import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroField, { IIntroFieldProps } from "../Components/IntroField";

/** A Text Field for gathering the Last Name.
 * Controlled from the Session Context.
 */
const SessionContextLastNameField = SessionContextValueProvider({
  Component: IntroField,
  map: ({ unverifiedCustomer, setCustomer, setUnverifiedCustomer }) => {
    return {
      value: unverifiedCustomer.lastName,
      onChangeValue: (lastName: string) => setUnverifiedCustomer(c => ({ ...c, lastName: lastName })),
      onChange: (lastName: string) => setCustomer(c => ({ ...c, lastName: lastName }))
    } as IIntroFieldProps;
  }
});

export default SessionContextLastNameField;
